import React from 'react'
import { createRoot } from 'react-dom/client';
import ReactDOM from 'react-dom'
import { BrowserRouter } from "react-router-dom";
import './index.css'
import App from './App'
import "@fortawesome/fontawesome-free/css/all.min.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import * as serviceWorker from './serviceWorker'


ReactDOM.render(
    <BrowserRouter>
      <App/>
  </BrowserRouter>, 
document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below.
const configuration = {
  onUpdate: (registration) => {
    if (registration && registration.waiting) {
      if (window.confirm('New version available!  refresh to update your app?')) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        window.location.reload();
      }
    }
  }
};
  
serviceWorker.register(configuration);
// serviceWorker.register(`./service-worker.js`)